import React from 'react';
import { motion } from 'framer-motion';
import { ChoiceButton } from '../components/ChoiceButton';
import { MolecularBackdrop } from '../components/MolecularBackdrop';
interface Props {
  onSelect: (value: string) => void;
  selectedValue?: string;
}
const options = [{
  id: 'lead_opt',
  label: 'Lead optimization'
}, {
  id: 'ind_enabling',
  label: 'IND enabling'
}, {
  id: 'cmc',
  label: 'CMC'
}, {
  id: 'early_clinical',
  label: 'Early clinical stage'
}, {
  id: 'late_clinical',
  label: 'Late clinical stage'
}, {
  id: 'commercial',
  label: 'Commercial stage'
}];
export function SlideSegment({
  onSelect,
  selectedValue
}: Props) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col relative px-5 pt-20 pb-28" data-id="element-658">
      <MolecularBackdrop variant="timeline" data-id="element-659" />

      <div className="relative z-10 flex-1 flex flex-col justify-center" data-id="element-660">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-661">
          <span className="text-minerva-blue text-[10px] font-bold tracking-[0.25em] uppercase mb-4 block" data-id="element-662">
            About You
          </span>
          <h2 className="text-[26px] font-display font-bold text-slate-900 leading-tight mb-7" data-id="element-663">
            Where in the drug development process do you fit best?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-2.5" data-id="element-664">
          {options.map((opt, i) => <ChoiceButton key={opt.id} label={opt.label} selected={selectedValue === opt.id} onClick={() => onSelect(opt.id)} delay={0.1 + i * 0.05} data-id="element-665" />)}
        </div>
      </div>
    </motion.div>;
}